module.exports = [
  {
    name: "Admin usuarios",
    icon: "cp-admin",
    modules: [
      {
        name: "Dashboard General",
        route: "/costa-pez/administrador/mi-cuenta"
      },
      {
        route: "/costa-pez/administrador/usuarios",
        name: "Mantenedor usuarios"
      },
      {
        route: "/costa-pez/administrador/especies",
        name: "Mantenedor especies"
      }
    ]
  }
];
